import { useSelector } from 'src/hooks/useSelector';

export const useIsPfpVacancy = (vacancyId?: number): boolean => {
    const isPfpVacancy = useSelector((state) => state.isPfpVacancy);
    const vacanciesInfo = useSelector((state) => state.candidatesList?.vacanciesInfo);

    if (isPfpVacancy !== null) {
        return isPfpVacancy;
    }

    if (vacancyId && vacanciesInfo) {
        return vacanciesInfo[vacancyId]?.pfp;
    }

    return false;
};

export const useHasPfpVacancy = (): boolean => {
    const vacanciesInfo = useSelector((state) => state.candidatesList?.vacanciesInfo) || {};

    return Object.values(vacanciesInfo).some((item) => item.pfp);
};
